// form
import { useFormContext, Controller } from 'react-hook-form';
// @mui
import { TextField, TextFieldProps } from '@mui/material';
import { uppercaseElementValue } from '../../utils/uppercase';

// ----------------------------------------------------------------------

type Props = TextFieldProps & {
  name: string;
  /** Store the typed value in CAPITALS (NHS forms, practitioner names). */
  uppercase?: boolean;
};

export default function RHFTextField({
  name,
  helperText,
  uppercase = false,
  ...other
}: Props) {
  const { control } = useFormContext();

  return (
    <Controller
      name={name}
      control={control}
      render={({ field, fieldState: { error } }) => (
        <TextField
          {...field}
          onChange={
            uppercase
              ? (event) => {
                  uppercaseElementValue(event.target);
                  field.onChange(event);
                }
              : field.onChange
          }
          fullWidth
          value={
            field.value === undefined || field.value === null ? '' : field.value
          }
          error={!!error}
          helperText={error ? error?.message : helperText}
          {...other}
        />
      )}
    />
  );
}
